import React from 'react'
import { Route, IndexRoute } from 'react-router'

import Container from './Container'
import Home from './Home'
import Page from './Page'
import Preview from './Preview'

export default (
  <Route path='/' component={Container}>
    <IndexRoute component={Home} />
    <Route path='preview' component={Preview} />
    <Route path=':slug' component={Page} />
  </Route>
)



// WEBPACK FOOTER //
// ./routes/index.js